export default "__VITE_ASSET__fc35e642__"